import { useEffect, useState } from 'react';
import screenSizes from '../../theme/shared/breakpoints';
const useResponsive = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [isTablet, setIsTablet] = useState(false);
    const [isLaptop, setIsLaptop] = useState(false);
    const [isDesktop, setIsDesktop] = useState(false);
    const handleResize = () => {
        const width = window.innerWidth;
        setIsMobile(width <= screenSizes.small);
        setIsTablet(width > screenSizes.small && width <= screenSizes.medium);
        setIsLaptop(width > screenSizes.medium && width <= screenSizes.large);
        setIsDesktop(width >= screenSizes.xLarge);
    };
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return {
        isMobile,
        isTablet,
        isLaptop,
        isDesktop,
    };
};
export default useResponsive;
//# sourceMappingURL=useResponsive.js.map